import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages } from 'react-intl';
import { decorateIntlMessages } from '../common/rosetta_formatted_message';
import SearchForm from './search_form';
import SearchResultsMessage from './search_results_message';
import classNames from 'classnames';

export const messages = decorateIntlMessages(__filename, defineMessages({
  placeholder: {
    id: 'placeholder',
    description: 'Placeholder text for the search box in some panel.',
    defaultMessage: 'Search'
  }
}));

const SearchPanel = ({
  fetchStatus,
  recordSearchTerm,
  resultsCount,
  searchTerm
}) => (
  <div className={classNames('search-panel', {
    'no-results': fetchStatus === 'fetchingOnSamePage' || resultsCount === 0
  })}
  >
    <SearchForm id="search-panel"
      shouldRenderSubmitButton
      defaultValue={searchTerm}
      placeholderMessage={messages.placeholder}
      recordSearchTerm={recordSearchTerm}
    />
    <SearchResultsMessage
      fetchStatus={fetchStatus}
      searchTerm={searchTerm}
      resultsCount={resultsCount}
    />
  </div>
);

SearchPanel.propTypes = {
  fetchStatus: PropTypes.string.isRequired,
  resultsCount: PropTypes.number.isRequired,
  searchTerm: PropTypes.string.isRequired,
  recordSearchTerm: PropTypes.func.isRequired
};

SearchPanel.defaultProps = {
  resultsCount: 0,
  searchTerm: ''
};

export default SearchPanel;
